import { getLoadedCommunicationChartAvatarImage } from '@web/components/CommunicationNetworkGraph/graph/communicationChartAvatarImageCache';
import { resolveCommunicationChartNodeInitialsFontSizePx } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
import { resolveCommunicationChartNodeHoverScale, resolveCommunicationChartOverlayOpacity } from '@web/components/CommunicationNetworkGraph/graph/communicationChartMotion';
import { drawCommunicationChartNodeCircle, drawCommunicationChartNodeInnerBorder, resolveCommunicationChartNodeVisual } from '@web/components/CommunicationNetworkGraph/graph/drawCommunicationChartNodeCircle';
var drawPersonAvatarImage = function (ctx, x, y, size, radius, image, opacity) {
    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(image, x - radius, y - radius, size, size);
    ctx.restore();
};
var drawPersonNode = function (ctx, node, opacity) {
    var _a, _b;
    var position = node.renderedPosition();
    var renderedSize = node.renderedWidth();
    if (!Number.isFinite(renderedSize) || renderedSize <= 0) {
        return;
    }
    var size = renderedSize * resolveCommunicationChartNodeHoverScale(node);
    var radius = size / 2;
    var avatarUrl = String((_a = node.data('avatarUrl')) !== null && _a !== void 0 ? _a : '');
    var initials = String((_b = node.data('initials')) !== null && _b !== void 0 ? _b : '?');
    var image = avatarUrl
        ? getLoadedCommunicationChartAvatarImage(avatarUrl)
        : null;
    var visual = resolveCommunicationChartNodeVisual(node);
    drawCommunicationChartNodeCircle({
        ctx: ctx,
        x: position.x,
        y: position.y,
        radius: radius,
        visual: visual,
        opacity: opacity,
        label: image ? undefined : initials,
        labelFontSizePx: resolveCommunicationChartNodeInitialsFontSizePx(size)
    });
    if (image) {
        drawPersonAvatarImage(ctx, position.x, position.y, size, radius, image, opacity);
        drawCommunicationChartNodeInnerBorder(ctx, position.x, position.y, radius, visual.borderColor, visual.borderWidth, opacity);
    }
};
export var drawCommunicationChartAvatarOverlay = function (cy, ctx) {
    cy.nodes('.personNode').forEach(function (node) {
        drawPersonNode(ctx, node, resolveCommunicationChartOverlayOpacity(node));
    });
};
